const ErrorCodeMapper = {
  user_not_found: '尚未成為會員',
  password_error: '密碼錯誤',
  verify_totp_error: '驗證碼錯誤',
  password_format_error: '密碼格式錯誤',
  duplicate_plate_number: '您已綁定此張車牌，請嘗試其他號碼',
  plate_number_already_exists: '車牌已被其他手機設定，請聯繫客服',
  sub_account_not_found: '找不到子帳號',
  'reports rate limit': '報表請求太過頻繁',
  export_time_should_between_one_month: '交易明細匯出日期以一個月為上限，請修改日期後重新匯出。',
};

export const errorHandler = error => {
  if (typeof error === 'string') {
    return error;
  }

  const { response } = error;

  if (response && response.status) {
    const { status, data } = response;
    switch (status) {
      case 400:
        return data.error;
      case 422:
        return ErrorCodeMapper[data.error?.code] || data.error?.message || '發生錯誤';
      case 500:
        return '伺服器發生錯誤';
      default:
        return error.message;
    }
  } else {
    console.log(error);
    return '發生未知錯誤';
  }
};

export const errorHandingWithCode = error => {
  const { response } = error;
  if (response && response.status) {
    const { status, data } = response;
    if (status === 422) {
      return {
        code: data.error.code,
        message: ErrorCodeMapper[data.error.code] || data.error.message,
      };
    } else {
      return {
        code: undefined,
        message: errorHandler(error),
      };
    }
  }
};
